import { useState } from "react"
import axiosInstance from "../../../services/axios-client"
import { toast } from "react-toastify"

const useSpmoDetail = () => {
    const [user, setUser] = useState()
    const [calibrations, setCalibrations] = useState()
    const [userNameOption, setUserNameOption] = useState();
    const [gradeOption, setGradeOption] = useState();
    const [supervisorNameOption, setSupervisorNameOption] = useState();
    const [divisionOption, setDivisionOption] = useState();

    // Modal Approval
    const [userApprove, setUserApprove] = useState()
    const [isAcceptModal, setIsAcceptModal] = useState()
    const [show, setShow] = useState(false)
    const handleClose = () => setShow(false)
    const handleShow = () => setShow(true)

    // Modal Justification
    const [userJustification, setUserJustification] = useState()
    const [showJustification, setShowJustification] = useState(false)
    const handleCloseJustification = () => setShowJustification(false)

    const [multipleAcceptJustification, setMultipleAcceptJustification] = useState([])
    const [checkBoxes, setCheckBoxes] = useState({});

    const [canSubmit, setCanSubmit] = useState(true)
    const [canCheckAll, setCanCheckAll] = useState(false)
    const [checkAll, setCheckAll] = useState(false)

    const [loadingPagestate, setLoadingPage] = useState(false)

    const [scoreDistribution, setScoreDistribution] = useState({})
    const [actualScore, setActualScore] = useState({
        APlus: 0,
        A: 0,
        BPlus: 0,
        B: 0,
        C: 0,
        D: 0
    })
    const [countCalibrated, setCountCalibrated] = useState({
        APlus: 0,
        A: 0,
        BPlus: 0,
        B: 0,
        C: 0,
        D: 0
    })
    const [ratingQuota, setRatingQuota] = useState({
        APlus: 0,
        A: 0,
        BPlus: 0,
        B: 0,
        C: 0,
        D: 0
    })
    const [deviationRating, setDeviationRating] = useState({
        APlus: 0,
        A: 0,
        BPlus: 0,
        B: 0,
        C: 0,
        D: 0
    })
    const [ratingState, setRatingState] = useState({
        'A+': 6,
        'A': 5,
        'B+': 4,
        'B': 3,
        'C': 2,
        'D': 1
    })
    const [averageAllScore, setAverage] = useState(0)


    const getAllCalibrations = async (spmo_id, calibrator_id, business_unit_id, order, department_name, project_id) => {
        try {
            setLoadingPage(true)
            let res
            if (!department_name) {
                res = await axiosInstance.get(`/auth/calibrations/spmo/${spmo_id}/${calibrator_id}/${business_unit_id}/${order}/${project_id}`)
            } else {
                res = await axiosInstance.get(`/auth/calibrations/spmo/${spmo_id}/${calibrator_id}/${business_unit_id}/${order}/${department_name}/${project_id}`)
            }
            if (res.status === 200) {
                let allCheckBoxes = {}
                let actualScoreCopy = { ...actualScore }
                let countCalibratedCopy = { ...countCalibrated }

                let count = 0
                let total = 0

                let allName = [];
                let grade = [];
                let supervisorName = [];
                let division = [];

                let hasWaitingStatus = false
                let allAcceptedAndNotReviewed = true

                for (const userData of res.data.data) {
                    allName.push({
                        label: userData.Name,
                        value: userData.Name
                    })
                    grade.push({
                        label: userData.Grade,
                        value: userData.Grade
                    })
                    supervisorName.push({
                        label: userData.SupervisorNames,
                        value: userData.SupervisorNames
                    })
                    if (userData.Division) {
                        division.push({
                            label: userData.Division,
                            value: userData.Division
                        })
                    }

                    let actualRating = userData.ActualScores[0].ActualRating.replace("+", "Plus")
                    actualScoreCopy[actualRating] += 1

                    let countCalibratedData = userData.CalibrationScores[userData.CalibrationScores.length - 1].CalibrationRating.replace("+", "Plus")
                    countCalibratedCopy[countCalibratedData] += 1

                    if (userData.ScoringMethod === "Score") {
                        count += 1
                        total += userData.CalibrationScores[userData.CalibrationScores.length - 1].CalibrationScore
                    }

                    if (userData.CalibrationScores[userData.CalibrationScores.length - 1].Status === "Complete" && userData.CalibrationScores[userData.CalibrationScores.length - 1].SpmoStatus === "Waiting") {
                        allCheckBoxes[userData.ID] = false
                    }

                    if (userData.CalibrationScores[userData.CalibrationScores.length - 1].SpmoStatus === "Waiting") {
                        hasWaitingStatus = true
                    }

                    // Check if this user meets submit criteria
                    if (!(userData.CalibrationScores[userData.CalibrationScores.length - 1].SpmoStatus === "Accepted" && userData.CalibrationScores[userData.CalibrationScores.length - 1].JustificationReviewStatus === false)) {
                        allAcceptedAndNotReviewed = false
                    }

                    let result_list = [];
                    let current_order = 1;
                    userData.CalibrationScores.forEach(item => {
                        let order = item.ProjectPhase.Phase.Order;
                        while (current_order < order) {
                            // let dataCalibrationBefore = userData.CalibrationScores[notMovingCurrentOrder-1]
                            let scoreNow = userData.ActualScores[0].ActualRating
                            // if (current_order > 1) {
                            //     scoreNow = userData.CalibrationScores[notMovingCurrentOrder-1]
                            // }
                            if (current_order === order - 1) {
                                if (userData.CalibrationScores.length > 1) {
                                    scoreNow = userData.CalibrationScores[userData.CalibrationScores.length - 2].CalibrationScore
                                }
                            }

                            result_list.push({
                                CalibrationRating: "",
                                CalibrationScore: 0,
                                CalibrationScoreBefore: scoreNow
                            });
                            current_order++;
                        }
                        if (order === 1 && userData.CalibrationScores.length > 1 && item.CalibrationRating === "") {
                            item.CalibrationScoreBefore = userData.ActualScores[0].ActualRating
                        }
                        result_list.push(item);
                        current_order++;
                    });


                    if (userData.CalibrationScores.length === 1) {
                        result_list[result_list.length - 1] = { ...result_list[result_list.length - 1], TopUser: true }
                    }

                    userData.CalibrationScores = result_list
                }

                // Set states after loop completes
                setCanCheckAll(hasWaitingStatus)
                setCanSubmit(allAcceptedAndNotReviewed)
                setActualScore(actualScoreCopy)
                setCountCalibrated(countCalibratedCopy)
                setUser(res.data.data)
                setCheckBoxes(allCheckBoxes)
                setLoadingPage(false)

                // Remove duplicates from allName
                allName = Array.from(new Set(allName.map(obj => JSON.stringify(obj)))).map(str => JSON.parse(str));
                allName.sort((a, b) => a.value.localeCompare(b.value));
                grade = Array.from(new Set(grade.map(obj => JSON.stringify(obj)))).map(str => JSON.parse(str));
                grade.sort((a, b) => a.value.localeCompare(b.value));
                supervisorName = Array.from(new Set(supervisorName.map(obj => JSON.stringify(obj)))).map(str => JSON.parse(str));
                supervisorName.sort((a, b) => a.value.localeCompare(b.value));
                division = Array.from(new Set(division.map(obj => JSON.stringify(obj)))).map(str => JSON.parse(str));
                division.sort((a, b) => a.value.localeCompare(b.value));
                setUserNameOption(allName)
                setGradeOption(grade)
                setSupervisorNameOption(supervisorName)
                setDivisionOption(division)

                let result = total / count
                if (count === 0) {
                    result = 0
                }
                setAverage(result)
            }
        } catch (error) {
            setLoadingPage(false)

            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const getScoreDistribution = async (businessUnit, project_id) => {
        try {
            let res = await axiosInstance.get(`/auth/projects/score-distribution?businessUnit=${businessUnit}&projectID=${project_id}`)
            if (res.status === 200) {
                setScoreDistribution(res.data.data)
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }

    }

    const getRatingQuota = async (spmo_id, calibrator_id, business_unit_id, order, project_id) => {
        try {
            let res = await axiosInstance.get(`/auth/calibrations/spmo/rating-quota/${spmo_id}/${calibrator_id}/${business_unit_id}/${order}/${project_id}`)
            if (res.status === 200) {
                setRatingQuota({ ...res.data.data })
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }

    }

    const onChangeHandler = (e, projectID, employeeID, projectPhaseID, calibratorID) => {
        if (e.target.type === "checkbox") {
            if (!e.target.checked) {
                const filteredData = multipleAcceptJustification.filter((item) => item.EmployeeID !== employeeID)
                setMultipleAcceptJustification(filteredData)
            } else {
                setMultipleAcceptJustification((prevPayload) => ([...prevPayload, {
                    ProjectID: projectID,
                    EmployeeID: employeeID,
                    ProjectPhaseID: projectPhaseID,
                    CalibratorID: calibratorID,
                }]));
            }

            setCheckBoxes((prevCheckBoxes) => ({
                ...prevCheckBoxes,
                [employeeID]: e.target.checked,
            }));


        }
    }

    const setMultipleJustificationDataByCheckbox = async (e, filterUser) => {
        setCheckAll(e.target.checked)
        setAllData(e.target.checked, filterUser)
    }

    const setAllData = (data, filterUser) => {
        if (data && filterUser) {
            let newCheckBox = { ...checkBoxes }
            for (const [key, _] of Object.entries(checkBoxes)) {
                newCheckBox[key] = true
            }
            setCheckBoxes(newCheckBox)

            let newAccept = []
            for (const userData of filterUser) {
                let calScoreData = userData.CalibrationScores
                if (calScoreData[calScoreData.length - 1].Status === "Complete" && calScoreData[calScoreData.length - 1].SpmoStatus === "Waiting") {
                    let dataUser = {
                        ProjectID: calScoreData[calScoreData.length - 1].ProjectID,
                        EmployeeID: calScoreData[calScoreData.length - 1].EmployeeID,
                        ProjectPhaseID: calScoreData[calScoreData.length - 1].ProjectPhaseID,
                        CalibratorID: calScoreData[calScoreData.length - 1].CalibratorID,
                    }

                    newAccept.push(dataUser)
                }
            }
            setMultipleAcceptJustification(newAccept)
        } else {
            let newCheckBox = { ...checkBoxes }
            for (const [key, _] of Object.entries(checkBoxes)) {
                newCheckBox[key] = false
            }
            setCheckBoxes(newCheckBox)

            let newAccept = []
            setMultipleAcceptJustification(newAccept)
        }
    }

    const acceptAllJustification = async () => {
        try {
            setLoadingPage(true)
            let res = await axiosInstance.post(`/auth/calibrations/accept-multiple-approval`, {
                ArrayOfAcceptsJustification: multipleAcceptJustification
            })
            if (res.status === 200) {
                setLoadingPage(false)
                toast.success("Successfully accept calibration")
                setTimeout(() => {
                    window.location.reload()
                }, 1000)
            }
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const submitReview = async () => {
        try {
            let newAccept = []
            for (const userData of user) {
                let calScoreData = userData.CalibrationScores
                newAccept.push({
                    ProjectID: calScoreData[calScoreData.length - 1].ProjectID,
                    EmployeeID: calScoreData[calScoreData.length - 1].EmployeeID,
                    ProjectPhaseID: calScoreData[calScoreData.length - 1].ProjectPhaseID,
                    CalibratorID: calScoreData[calScoreData.length - 1].CalibratorID,
                })
            }
            console.log("newAccept:", newAccept)

            setLoadingPage(true)
            let res = await axiosInstance.post(`/auth/calibrations/spmo/submit`, {
                ArrayOfAcceptsJustification: newAccept
            })
            if (res.status === 200) {
                setLoadingPage(false)
                toast.success("Successfully submit calibration into another phase")
                setTimeout(() => {
                    window.location.reload()
                }, 1000)
            }
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const updateTable = (
        calibratedUsers,
        sortScoreLatest,
        sortRatingLatest,
        filterRating,
        sortScoreLatestMinusOne,
        sortRatingLatestMinusOne,
        filterRatingBefore,
        sortName,
        customOrder,
        latestCalibration,
        setFilteredUser,
        sortGrade,
        filterUserName,
        filterGrade,
        filterSupervisorName,
        filterChangeScore,
        filterDivision,
        sortActualScore,
        sortActualRating,
        filterActualRating,
    ) => {

        let sortedList = [...calibratedUsers]

        // Default sort: 1) Latest Calibration Rating DESC, 2) Latest Calibration Score DESC, 3) Grade numeric DESC, 4) Grade alpha DESC, 5) Name ASC
        sortedList = sortedList.sort((a, b) => {
            // First: Sort by latest calibration rating (descending)
            const ratingDiff = customOrder[b.CalibrationScores[b.CalibrationScores.length - 1].CalibrationRating] - customOrder[a.CalibrationScores[a.CalibrationScores.length - 1].CalibrationRating];
            if (ratingDiff !== 0) return ratingDiff;

            // Second: Sort by latest calibration score (descending)
            const scoreDiff = b.CalibrationScores[b.CalibrationScores.length - 1].CalibrationScore - a.CalibrationScores[a.CalibrationScores.length - 1].CalibrationScore;
            if (scoreDiff !== 0) return scoreDiff;

            // Third: Sort by grade - extract numeric part (descending)
            const gradeNumA = parseInt((a.Grade || '').replace(/\D.*/g, '') || '0');
            const gradeNumB = parseInt((b.Grade || '').replace(/\D.*/g, '') || '0');
            const gradeNumDiff = gradeNumB - gradeNumA;
            if (gradeNumDiff !== 0) return gradeNumDiff;

            // Fourth: Sort by grade - extract alphabetic part (descending)
            const gradeAlphaA = (a.Grade || '').replace(/^\d+/g, '');
            const gradeAlphaB = (b.Grade || '').replace(/^\d+/g, '');
            const gradeAlphaDiff = gradeAlphaB.localeCompare(gradeAlphaA);
            if (gradeAlphaDiff !== 0) return gradeAlphaDiff;

            // Fifth: Sort by name (ascending)
            return (a.Name || '').localeCompare(b.Name || '');
        })

        if (sortActualScore === "ascending") {
            sortedList = sortedList.sort((a, b) => a.ActualScores[0].ActualScore - b.ActualScores[0].ActualScore)
        } else if (sortActualScore === "descending") {
            sortedList = sortedList.sort((a, b) => b.ActualScores[0].ActualScore - a.ActualScores[0].ActualScore)
        }

        if (sortActualRating === "ascending") {
            sortedList = sortedList.sort((a, b) => customOrder[a.ActualScores[0].ActualRating] - customOrder[b.ActualScores[0].ActualRating]);
        } else if (sortActualRating === "descending") {
            sortedList = sortedList.sort((a, b) => customOrder[b.ActualScores[0].ActualRating] - customOrder[a.ActualScores[0].ActualRating]);
        }

        if (filterActualRating !== 'None') {
            sortedList = sortedList.filter((data) => data.ActualScores[0].ActualRating === filterActualRating)
        }

        if (sortScoreLatest === "ascending") {
            sortedList = sortedList.sort((a, b) => a.CalibrationScores[a.CalibrationScores.length - 1].CalibrationScore - b.CalibrationScores[b.CalibrationScores.length - 1].CalibrationScore)
        } else if (sortScoreLatest === "descending") {
            sortedList = sortedList.sort((a, b) => b.CalibrationScores[b.CalibrationScores.length - 1].CalibrationScore - a.CalibrationScores[a.CalibrationScores.length - 1].CalibrationScore)
        }

        if (sortRatingLatest === "ascending") {
            sortedList = sortedList.sort((a, b) => customOrder[a.CalibrationScores[a.CalibrationScores.length - 1].CalibrationRating] - customOrder[b.CalibrationScores[b.CalibrationScores.length - 1].CalibrationRating]);
        } else if (sortRatingLatest === "descending") {
            sortedList = sortedList.sort((a, b) => customOrder[b.CalibrationScores[b.CalibrationScores.length - 1].CalibrationRating] - customOrder[a.CalibrationScores[a.CalibrationScores.length - 1].CalibrationRating]);
        }

        if (filterRating !== 'None') {
            sortedList = sortedList.filter((data) => data.CalibrationScores[data.CalibrationScores.length - 1].CalibrationRating === filterRating)
        }

        if (sortScoreLatestMinusOne === "ascending") {
            sortedList = sortedList.sort((a, b) => a.CalibrationScores[a.CalibrationScores.length + latestCalibration].CalibrationScore - b.CalibrationScores[b.CalibrationScores.length + latestCalibration].CalibrationScore)
        } else if (sortScoreLatestMinusOne === "descending") {
            sortedList = sortedList.sort((a, b) => b.CalibrationScores[b.CalibrationScores.length + latestCalibration].CalibrationScore - a.CalibrationScores[a.CalibrationScores.length + latestCalibration].CalibrationScore)
        }

        if (sortRatingLatestMinusOne === "ascending") {
            sortedList = sortedList.sort((a, b) => customOrder[a.CalibrationScores[a.CalibrationScores.length + latestCalibration].CalibrationRating] - customOrder[b.CalibrationScores[b.CalibrationScores.length + latestCalibration].CalibrationRating]);
        } else if (sortRatingLatestMinusOne === "descending") {
            sortedList = sortedList.sort((a, b) => customOrder[b.CalibrationScores[b.CalibrationScores.length + latestCalibration].CalibrationRating] - customOrder[a.CalibrationScores[a.CalibrationScores.length + latestCalibration].CalibrationRating]);
        }

        if (filterRatingBefore !== 'None') {
            sortedList = sortedList.filter((data) => data.CalibrationScores[data.CalibrationScores.length + latestCalibration].CalibrationRating === filterRatingBefore)
        }

        if (!sortedList) {
            setFilteredUser([])
        }

        if (sortName === "ascending") {
            sortedList = sortedList.sort(function (a, b) {
                if (a.Name < b.Name) {
                    return -1;
                }
                if (a.Name > b.Name) {
                    return 1;
                }
                return 0;
            })
        } else if (sortName === "descending") {
            sortedList = sortedList.sort(function (a, b) {
                if (a.Name > b.Name) {
                    return -1;
                }
                if (a.Name < b.Name) {
                    return 1;
                }
                return 0;
            })
        }

        if (sortGrade === "ascending") {
            sortedList = sortedList.sort(function (a, b) {
                // Extract numeric part (e.g., "5" from "5A")
                const gradeNumA = parseInt((a.Grade || '').replace(/\D.*/g, '') || '0');
                const gradeNumB = parseInt((b.Grade || '').replace(/\D.*/g, '') || '0');

                // First compare by numeric part
                if (gradeNumA !== gradeNumB) {
                    return gradeNumA - gradeNumB;
                }

                // If numeric parts are equal, compare by alphabetic part (e.g., "A" from "5A")
                const gradeAlphaA = (a.Grade || '').replace(/^\d+/g, '');
                const gradeAlphaB = (b.Grade || '').replace(/^\d+/g, '');
                return gradeAlphaA.localeCompare(gradeAlphaB);
            })
        } else if (sortGrade === "descending") {
            sortedList = sortedList.sort(function (a, b) {
                // Extract numeric part (e.g., "5" from "5A")
                const gradeNumA = parseInt((a.Grade || '').replace(/\D.*/g, '') || '0');
                const gradeNumB = parseInt((b.Grade || '').replace(/\D.*/g, '') || '0');

                // First compare by numeric part (descending)
                if (gradeNumA !== gradeNumB) {
                    return gradeNumB - gradeNumA;
                }

                // If numeric parts are equal, compare by alphabetic part descending
                const gradeAlphaA = (a.Grade || '').replace(/^\d+/g, '');
                const gradeAlphaB = (b.Grade || '').replace(/^\d+/g, '');
                return gradeAlphaB.localeCompare(gradeAlphaA);
            })
        }

        if (filterUserName) {
            if (filterUserName.length > 0) {
                sortedList = sortedList.filter(user => filterUserName.includes(user.Name));
            }
        }
        if (filterGrade) {
            if (filterGrade.length > 0) {
                sortedList = sortedList.filter(user => filterGrade.includes(user.Grade));
            }
        }
        if (filterSupervisorName) {
            if (filterSupervisorName.length > 0) {
                sortedList = sortedList.filter(user => filterSupervisorName.includes(user.SupervisorNames));
            }
        }
        if (filterDivision) {
            if (filterDivision.length > 0) {
                sortedList = sortedList.filter(user => filterDivision.includes(user.Division));
            }
        }

        if (filterChangeScore === 'changed') {
            sortedList = sortedList.filter(user => {
                let userCalibration = calibratedUsers.filter(obj => obj.ID === user.ID)
                let lengthCalibrationScores = userCalibration[0].CalibrationScores.length;
                let calLength = lengthCalibrationScores - 2

                let scoreBefore = 0
                let ratingBefore = ""
                while (calLength >= 0) {
                    scoreBefore = userCalibration[0].CalibrationScores[calLength].CalibrationScore
                    ratingBefore = userCalibration[0].CalibrationScores[calLength].CalibrationRating
                    calLength--;
                    if (scoreBefore && ratingBefore) {
                        break
                    }
                }
                if (!scoreBefore && !ratingBefore) {
                    scoreBefore = userCalibration[0].ActualScores[0].ActualScore
                    ratingBefore = userCalibration[0].ActualScores[0].ActualRating
                }

                if (userCalibration[0].CalibrationScores[lengthCalibrationScores - 1].CalibrationScore !== scoreBefore
                    || userCalibration[0].CalibrationScores[lengthCalibrationScores - 1].CalibrationRating !== ratingBefore) {
                    return true
                }
                return false
            })
        } else if (filterChangeScore === 'unchanged') {
            sortedList = sortedList.filter(user => {
                let userCalibration = calibratedUsers.filter(obj => obj.ID === user.ID)
                let lengthCalibrationScores = userCalibration[0].CalibrationScores.length;
                let calLength = lengthCalibrationScores - 2

                let scoreBefore
                let ratingBefore = ""
                while (calLength >= 0) {
                    scoreBefore = userCalibration[0].CalibrationScores[calLength].CalibrationScore
                    ratingBefore = userCalibration[0].CalibrationScores[calLength].CalibrationRating
                    calLength--;
                    if (scoreBefore && ratingBefore) {
                        break
                    }
                }

                if (!scoreBefore && !ratingBefore) {
                    scoreBefore = userCalibration[0].ActualScores[0].ActualScore
                    ratingBefore = userCalibration[0].ActualScores[0].ActualRating
                }

                if ((userCalibration[0].ScoringMethod === "Rating" && userCalibration[0].CalibrationScores[lengthCalibrationScores - 1].CalibrationRating === ratingBefore)
                    || (userCalibration[0].ScoringMethod === "Score" && userCalibration[0].CalibrationScores[lengthCalibrationScores - 1].CalibrationScore === scoreBefore)) {
                    return true
                }
                return false
            })
        } else if ((filterChangeScore >= 1 && filterChangeScore <= 4) || (filterChangeScore >= -4 && filterChangeScore <= -1)) {
            let dataFilterChangeScore = filterChangeScore
            sortedList = sortedList.filter(user => {
                let userCalibration = calibratedUsers.filter(obj => obj.ID === user.ID)
                let lengthCalibrationScores = userCalibration[0].CalibrationScores.length;
                let calLength = lengthCalibrationScores - 2

                let scoreBefore = 0
                let ratingBefore = ""
                while (calLength >= 0) {
                    scoreBefore = userCalibration[0].CalibrationScores[calLength].CalibrationScore
                    ratingBefore = userCalibration[0].CalibrationScores[calLength].CalibrationRating
                    calLength--;
                    if (scoreBefore && ratingBefore) {
                        break
                    }
                }
                if (!scoreBefore && !ratingBefore) {
                    scoreBefore = userCalibration[0].ActualScores[0].ActualScore
                    ratingBefore = userCalibration[0].ActualScores[0].ActualRating
                }

                let ratingNow = userCalibration[0].CalibrationScores[lengthCalibrationScores - 1].CalibrationRating
                let difference = ratingState[ratingNow] - ratingState[ratingBefore]

                if (difference === dataFilterChangeScore) {
                    return true
                }
                return false
            })

        }

        setFilteredUser(sortedList)
    }

    return {
        user,
        getAllCalibrations,
        userApprove,
        setUserApprove,
        isAcceptModal,
        setIsAcceptModal,
        show,
        handleShow,
        handleClose,
        calibrations,
        userJustification,
        showJustification,
        handleCloseJustification,
        multipleAcceptJustification,
        checkBoxes,
        acceptAllJustification,
        canSubmit,
        checkAll,
        setMultipleJustificationDataByCheckbox,
        submitReview,
        loadingPagestate,
        onChangeHandler,
        canCheckAll,
        setLoadingPage,
        ratingQuota,
        getRatingQuota,
        scoreDistribution,
        getScoreDistribution,
        actualScore,
        countCalibrated,
        deviationRating,
        setDeviationRating,
        averageAllScore,
        updateTable,
        userNameOption,
        gradeOption,
        supervisorNameOption,
        divisionOption,
    }

}

export default useSpmoDetail